import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from 'lodash';

import Intro from './Intro';
import { campaignReset } from '../../actions/createCampaign';

const mapDispatchToProps = dispatch => ({
  onStart: () => dispatch(campaignReset()),
});

class IntroContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showChildren: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onStart } = this.props;
    onStart();
    this.setState({ showChildren: true });
  }

  render() {
    const { children } = this.props;
    const { showChildren } = this.state;
    return (
      <React.Fragment>
        {!showChildren && <Intro onClick={this.handleClick} />}
        {showChildren && children}
      </React.Fragment>
    );
  }
}

IntroContainer.defaultProps = {
  onStart: noop,
};

IntroContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  onStart: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(IntroContainer);



// WEBPACK FOOTER //
// ./src/containers/createCampaign/IntroContainer.js